(function () {
    "use strict";

    angular
        .module("app")
        .component("home", {
            templateUrl: "src/app/home/home.html",
            controller: homeController
        });


    function homeController($scope, session) {
        const $ctrl = this;
        $ctrl.session = session;
        $scope.home = true;
    }
    homeController.$inject = ["$scope", "sessionService"];


})()